import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { Project, ProjectGetAllParams } from 'interfaces/api/projects.interfaces'
import { CreateProjectParams, RemoveProjectParams, UpdateProjectParams } from 'interfaces/store/projects.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllProjects = createAsyncThunk(
  'projects/getAllProjects',
  async (params: ProjectGetAllParams | undefined, { rejectWithValue }) =>
    api.projects.getAll(params).catch((error) => rejectWithValue(error.message)),
)

export const getProject = createAsyncThunk('projects/getProject', async (id: number, { rejectWithValue }) =>
  api.projects.getSingle(id).catch((error) => rejectWithValue(error.message)),
)

export const setSingleProject = createAction<null | Project>('users/setSingleProject')
export const setProjectValidationErrors = createAction<ValidationErrorsApi | null>(
  'projects/setProjectValidationErrors',
)

export const createProject = createAsyncThunk(
  'projects/createProject',
  async (params: CreateProjectParams, { rejectWithValue, dispatch }) =>
    api.projects
      .create(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setProjectValidationErrors(null))
        toast.success(Success.ProjectCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setProjectValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateProject = createAsyncThunk(
  'projects/updateProject',
  async (params: UpdateProjectParams, { rejectWithValue, dispatch }) =>
    api.projects
      .update(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setProjectValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setProjectValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeProject = createAsyncThunk(
  'projects/removeProject',
  async (params: RemoveProjectParams, { rejectWithValue }) =>
    api.projects
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.ProjectRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)

export const getProjectTypes = createAsyncThunk('projects/getProjectTypes', async (_, { rejectWithValue }) =>
  api.projects.getTypes().catch((error) => rejectWithValue(error.message)),
)

export const getLevels = createAsyncThunk('projects/getLevels', async (id: number, { rejectWithValue }) =>
  api.projects.getLevels(id).catch((error) => rejectWithValue(error.message)),
)
